import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MemberPaths } from 'src/app/constants/routes';
import { DashboardPayCheckModel } from 'src/app/models/payroll';

class PaycheckDetailsDoughnut {
    detail: string;
    val: number;
}
@Component({
    selector: 'mwp-paycheck-details',
    templateUrl: 'paycheck-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PaycheckDetailsComponent implements OnInit {
    @Input() dashboardPayCheckModel: DashboardPayCheckModel;
    paycheckDetails: PaycheckDetailsDoughnut[] = [];
    constructor(
        private router: Router,
    ) { }

    ngOnInit() {
        this.initializePaycheckDetails();
    }

    private initializePaycheckDetails(): void {
        this.paycheckDetails = [

            {
                detail: 'Deductions',
                val: this.dashboardPayCheckModel.deductions,
            },
            {
                detail: 'Taxes',
                val: this.dashboardPayCheckModel.taxes,
            },
            {
                detail: 'Net Pay',
                val: this.dashboardPayCheckModel.netPay,
            },
        ];
    }


    customizeTooltip(arg: any) {
        return { text: `${arg.argumentText}: <br>${arg.valueText}` };
    }
    customizePoint = (point: any) => {
        // const color = point.series.getPointsByArg(point.argument)[0].getColor();
        let fillId;
        switch (point.argument) {
            case 'Net Pay':
                fillId = "var(--formLabel)"
                break;
            case 'Deductions':
                fillId = "var(--devxlabelOne)"
                break;
            case 'Taxes':
                fillId = "var(--devxlabelTwo)"
                break;
            default:
                break;
        }

        return { color: { fillId } };
    };

    public goToPayHistory(): void {
        this.router.navigateByUrl(MemberPaths.PayrollPayStubs);
    }
}